import React, { useEffect, useState } from 'react';
import api from '../api';
import { useTheme } from '../contexts/ThemeContext';

const SUBE_RENK = ['#6366F1','#10B981','#F59E0B','#EC4899','#3B82F6','#8B5CF6'];

export default function KullaniciYonetimi() {
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [subeler, setSubeler] = useState<any[]>([]);
  const [yoneticiler, setYoneticiler] = useState<Record<string, { id: string; email: string }[]>>({});
  const [emailInputs, setEmailInputs] = useState<Record<string, string>>({});
  const [ekleniyor, setEkleniyor] = useState<Record<string, boolean>>({});
  const [kaldiriliyor, setKaldiriliyor] = useState<string | null>(null);

  useEffect(() => {
    api.get('/api/subeler').then(r => {
      const liste = r.data.filter((s: any) => s.aktif);
      setSubeler(liste);
      Promise.all(
        liste.map((s: any) =>
          api.get(`/api/subeler/${s.id}`).then(r2 => ({ id: s.id, yon: r2.data.yoneticiler || [] }))
        )
      ).then(results => {
        const map: Record<string, { id: string; email: string }[]> = {};
        results.forEach(r2 => { map[r2.id] = r2.yon; });
        setYoneticiler(map);
      });
    }).catch(console.error);
  }, []);

  const yoneticiEkle = async (subeId: string) => {
    const email = (emailInputs[subeId] || '').trim();
    if (!email) return;
    setEkleniyor(p => ({ ...p, [subeId]: true }));
    try {
      await api.post(`/api/subeler/${subeId}/yoneticiler`, { email });
      const r = await api.get(`/api/subeler/${subeId}`);
      setYoneticiler(p => ({ ...p, [subeId]: r.data.yoneticiler || [] }));
      setEmailInputs(p => ({ ...p, [subeId]: '' }));
    } catch (err: any) {
      alert(err.response?.data?.hata || 'Eklenemedi');
    } finally {
      setEkleniyor(p => ({ ...p, [subeId]: false }));
    }
  };

  const yoneticiKaldir = async (subeId: string, yoneticiId: string) => {
    setKaldiriliyor(yoneticiId);
    try {
      await api.delete(`/api/subeler/${subeId}/yoneticiler/${yoneticiId}`);
      setYoneticiler(p => ({ ...p, [subeId]: (p[subeId] || []).filter(y => y.id !== yoneticiId) }));
    } catch (err: any) {
      alert(err.response?.data?.hata || 'Kaldırılamadı');
    } finally {
      setKaldiriliyor(null);
    }
  };

  return (
    <div style={{ padding: '24px 28px', maxWidth: 960 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: textPrimary, margin: 0 }}>Kullanıcı Yönetimi</h1>
        <div style={{ fontSize: 13, color: textMuted, marginTop: 4 }}>
          Şube yöneticilerini buradan atayın. Yöneticiler Google ile giriş yapabilir.
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
        {subeler.map((sube: any, idx: number) => {
          const renk = SUBE_RENK[idx % SUBE_RENK.length];
          const subeYoneticileri = yoneticiler[sube.id] || [];
          const emailVal = emailInputs[sube.id] || '';
          const yukleniyor = ekleniyor[sube.id];

          return (
            <div key={sube.id} style={{ border: `1px solid ${border}`, borderRadius: 12, overflow: 'hidden', background: card }}>
              <div style={{ background: renk, padding: '12px 16px', display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'white', flex: 1 }}>{sube.ad}</span>
                <span style={{ background: 'rgba(255,255,255,0.25)', color: 'white', borderRadius: 20, padding: '1px 8px', fontSize: 11, fontWeight: 600 }}>
                  {subeYoneticileri.length} yönetici
                </span>
              </div>

              <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {subeYoneticileri.length === 0 ? (
                  <div style={{ fontSize: 12, color: textMuted, fontStyle: 'italic', padding: '4px 0' }}>
                    Henüz yönetici eklenmemiş
                  </div>
                ) : (
                  subeYoneticileri.map(y => (
                    <div key={y.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', background: cardAlt, borderRadius: 8 }}>
                      <div style={{ width: 28, height: 28, borderRadius: '50%', background: renk + '22', color: renk, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>
                        {y.email.charAt(0).toUpperCase()}
                      </div>
                      <span style={{ flex: 1, fontSize: 13, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {y.email}
                      </span>
                      <button
                        onClick={() => yoneticiKaldir(sube.id, y.id)}
                        disabled={kaldiriliyor === y.id}
                        style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#9CA3AF', fontSize: 18, lineHeight: 1, padding: '2px 4px', borderRadius: 4, flexShrink: 0 }}
                        title="Kaldır"
                      >
                        ×
                      </button>
                    </div>
                  ))
                )}

                <div style={{ display: 'flex', gap: 6, marginTop: 2 }}>
                  <input
                    type="email"
                    placeholder="yeni@email.com"
                    value={emailVal}
                    onChange={e => setEmailInputs(p => ({ ...p, [sube.id]: e.target.value }))}
                    onKeyDown={e => { if (e.key === 'Enter') yoneticiEkle(sube.id); }}
                    style={{ flex: 1, border: '1px solid #E5E7EB', borderRadius: 7, padding: '8px 10px', fontSize: 13, outline: 'none', color: '#374151' }}
                  />
                  <button
                    onClick={() => yoneticiEkle(sube.id)}
                    disabled={yukleniyor || !emailVal.trim()}
                    style={{
                      padding: '8px 16px', borderRadius: 7, border: 'none',
                      background: yukleniyor || !emailVal.trim() ? '#E5E7EB' : renk,
                      color: yukleniyor || !emailVal.trim() ? '#9CA3AF' : 'white',
                      fontSize: 13, fontWeight: 600,
                      cursor: yukleniyor || !emailVal.trim() ? 'default' : 'pointer',
                    }}
                  >
                    {yukleniyor ? '...' : 'Ekle'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
